







































import { defineComponent, getCurrentInstance, onBeforeUnmount, ref, watch } from "@vue/composition-api";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useCheckVerificationCode from "@/hooks/useEmailVerification";
import { ACTION_TYPES } from "@/store/const";
import emitter from "@/lib/emitter";
import { getProfileUrl } from "@/lib/urlHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import LoginComponent from "@/components/LoginComponent";
import ModalView from "@/components/ModalView";
import SignUpComponent from "@/components/SignUpComponent";
import SignUpEmailConfirm from "@/components/SignUpEmailConfirm";
import SignUpEmailConfirmCode from "@/components/SignUpEmailConfirmCode";
export default defineComponent({
  name: "LoginSignUpModal",
  components: {
    BaseButton,
    BaseConfirm,
    LoginComponent,
    SignUpComponent,
    SignUpEmailConfirm,
    SignUpEmailConfirmCode,
    ModalView,
  },
  setup() {
    const { authUser, allowAccess, socialLogin } = useAuthUser();
    const { startPeriodicalConfirmationCheck, stopPeriodicalConfirmationCheck } = useCheckVerificationCode();

    const vm = getCurrentInstance();
    const show = ref(false);
    const step = ref("signup");
    const tab = ref("member");
    const showConfirm = ref(false);
    const isSwitchAccount = ref(false);
    const referralId = ref("");

    const showModal = ({
      showLogin = false,
      isSwitch = false,
      currentReferralId,
    }: {
      showLogin?: boolean;
      isSwitch?: boolean;
      currentReferralId: string;
    }) => {
      referralId.value = currentReferralId;
      show.value = true;
      isSwitchAccount.value = isSwitch;
      if (showLogin) {
        step.value = "login";
      }
    };
    const closeModal = async (result = true) => {
      try {
        if (!result) {
          return;
        }
        if (authUser.value && !allowAccess.value) {
          await vm?.$store.dispatch(ACTION_TYPES.LOGOUT);
        }
        show.value = false;
        step.value = "signup";
      } finally {
        showConfirm.value = false;
      }
    };
    const onCloseModal = () => {
      if (authUser.value && !allowAccess.value) {
        showConfirm.value = true;
      } else {
        closeModal();
      }
    };
    const onLogin = async (user: User) => {
      if (!allowAccess.value && socialLogin.value) {
        step.value = "emailConfirm";
      } else if (!allowAccess.value) {
        step.value = "codeConfirm";
      } else {
        if (tab.value === "creator") {
          vm?.$router.push({ name: "profilePayeeInfo" });
        }
        await closeModal();
        if (isSwitchAccount.value) {
          if (user.role === "creator") {
            vm?.$router.push(getProfileUrl(user));
          } else {
            vm?.$router.push({ name: "home" });
          }
        }
      }
    };
    const onGo = async (path: string, evt?: { e: MouseEvent; navigate: Function }) => {
      if (evt) {
        evt.e.preventDefault();
        evt.e.stopPropagation();
      }
      if (path === "backFromConfirm") {
        await vm?.$store.dispatch(ACTION_TYPES.LOGOUT);
        step.value = "signup";
      } else if (path === "forgot") {
        vm?.$router.push({ name: "loginForgot" });
        await closeModal();
      } else {
        step.value = path;
      }
    };
    watch(step, newStep => {
      if (newStep === "codeConfirm") {
        startPeriodicalConfirmationCheck(closeModal);
      } else {
        stopPeriodicalConfirmationCheck();
      }
    });

    emitter.on<any>(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, showModal);
    onBeforeUnmount(() => emitter.off<any>(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, showModal));

    return {
      show,
      step,
      tab,
      referralId,
      showConfirm,
      closeModal,
      onCloseModal,
      onGo,
      onLogin,
    };
  },
});
